import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { Parte } from './partes.model';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { ActivatedRoute } from "@angular/router";
import { NotificationsService } from '../core/service/notifications.service';

@Injectable({
  providedIn: 'root' // Poner aquí esta declaración hace que no sea necesario meterlo en providers de app.module
})
export class PartesService {

  private partesURL: string = urlJoin(environment.apiURL, 'partes')

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService
  ) { }

  getPartes(id_expediente: string): Observable<Parte[]> {
    const getPartesURL = urlJoin(this.partesURL, '/expediente/', id_expediente)
    return this.http.get<Parte[]>(getPartesURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  getParte(id: string): Observable<any> {
    const getParteURL = urlJoin(this.partesURL, id)
    return this.http.get<Parte>(getParteURL)
      .pipe(
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  updateParte(id: string, parte: Parte): Observable<any> {
    const updateParteURL = urlJoin(this.partesURL, id)
    return this.http.put<Parte>(updateParteURL, parte)
      .pipe(
        tap(() => {
          const updateParteSuccessMessage: string = $localize`:@@updateParteSuccessMessage:Parte modificada correctamente`;
          this.notificationsService.showSuccessNotification(updateParteSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  deleteParte(id: string): Observable<any> {
    const deleteParteURL = urlJoin(this.partesURL, id)
    return this.http.delete<Parte>(deleteParteURL)
      .pipe(
        tap(() => {
          const deleteParteSuccessMessage: string = $localize`:@@deleteParteSuccessMessage:Parte eliminada correctamente`;
          this.notificationsService.showSuccessNotification(deleteParteSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  newParte(parte: Parte): Observable<any> {
    const newParteURL = urlJoin(this.partesURL, "/expediente")
    return this.http.post<Parte>(newParteURL, parte)
      .pipe(
        tap(() => {
          const newParteSuccessMessage: string = $localize`:@@newParteSuccessMessage:Nueva parte creada correctamente`;
          this.notificationsService.showSuccessNotification(newParteSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

}
